import { useEffect, useState } from "react";
import { listMessagesForUser, WhatsAppMessage } from "../lib/whatsappMessages";

const INTENT_LABEL: Record<string, string> = {
  blog_idea: "blog-idee", support_question: "support-vraag", unclear: "onduidelijk", blocked: "geblokkeerd",
};

export function WhatsAppConversation({ userId }: { userId: string }) {
  const [messages, setMessages] = useState<WhatsAppMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    listMessagesForUser(userId)
      .then((m) => { if (active) setMessages(m); })
      .catch((e) => { if (active) setError(e.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [userId]);

  if (loading) return <p className="text-gray-500">Laden…</p>;
  if (error) return <p className="text-red-600">Kon de conversatie niet laden: {error}</p>;
  if (messages.length === 0) return <p className="text-gray-500">Nog geen WhatsApp-berichten.</p>;

  return (
    <div className="space-y-2">
      {messages.map((m) => (
        <div key={m.id} className={`flex ${m.direction === "out" ? "justify-end" : "justify-start"}`}>
          <div className={`max-w-[75%] rounded-2xl px-3 py-2 ${m.direction === "out" ? "bg-[#FF6B35] text-white" : "bg-gray-100 text-gray-900"}`}>
            <p className="whitespace-pre-wrap text-sm">{m.body ?? <em>(geen tekst / media)</em>}</p>
            <div className="mt-1 flex items-center gap-2 text-[11px] opacity-70">
              <span>{new Date(m.created_at).toLocaleString("nl-NL")}</span>
              {m.direction === "in" && m.intent && <span className="rounded bg-black/10 px-1">{INTENT_LABEL[m.intent] ?? m.intent}</span>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
